import { EventDefinition } from 'redux-beacon'
import { UploadEndEvent } from '../actions/upload'
import { selectSite } from '../selectors/site'
import { EVENT_TYPES, PAPER_UPLOAD_STATES } from './constants'
import { getCharacterCount, getFileExtension, getWordCount } from '../util/helpers'
import { EventWithConfig } from './types'
import { getViewContext } from './helpers'

export const uploadStartEvent: EventDefinition = (action): EventWithConfig => {
  return {
    payload: {
      type: EVENT_TYPES.PAPER_UPLOAD,
      data: {
        state: PAPER_UPLOAD_STATES.start,
      },
    },
  }
}

export const uploadEndEvent: EventDefinition = (action): EventWithConfig => {
  const { uploadId, text, filename } = action.payload as UploadEndEvent
  const wordCount = getWordCount(text)
  const characterCount = getCharacterCount(text)
  const fileType = getFileExtension(filename)
  return {
    payload: {
      type: EVENT_TYPES.PAPER_UPLOAD,
      data: {
        state: PAPER_UPLOAD_STATES.end,
        upload_id: uploadId,
        word_count: wordCount,
        character_count: characterCount,
        file_type: fileType,
        failed: false,
      },
    },
    config: { force: true },
  }
}

export const pageViewEvent: EventDefinition = (action, prevState, nextState): EventWithConfig => ({
  payload: {
    type: EVENT_TYPES.CLICKSTREAM_VIEW,
    data: {},
  },
  config: { stateUpdate: { view: getViewContext(selectSite(nextState)) } },
})
